import { Navigate } from 'react-router-dom';
import Page404 from '@/common/views/Page404';
import AccountOrganizationsPage from './views/Organizations';
import AccountSettingsPage from './views/Settings';

export const accountRoutes = [
  {
    path: 'account',
    name: '个人设置',
    icon: 'user',
    hideInMenu: true,
    children: [
      {
        index: true,
        element: <Navigate to="settings" replace />,
      },
      {
        path: 'settings',
        name: '个人信息',
        icon: 'setting',
        element: <AccountSettingsPage />,
      },
      {
        path: 'organizations',
        name: '组织管理',
        icon: 'team',
        element: <AccountOrganizationsPage />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
];
